// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"22050ef8","787":"b701888c"}[chunkId] + ".chunk.js";
};